import React from 'react';

export const Features = () => {
  const features = [
    {
      icon: 'solar:crown-star-linear',
      title: 'AUTO BRACKETS',
      description: 'Generate double elimination brackets instantly. No manual entry. Just play.',
      bgColor: 'bg-gradient-to-r from-yellow-400 to-yellow-600',
      textColor: 'text-black',
    },
    {
      icon: 'solar:graph-up-linear',
      title: 'REAL-TIME STATS',
      description: 'Track win rates, domino counts, and match history live as each game unfolds.',
      bgColor: 'bg-gradient-to-r from-yellow-400 to-yellow-600',
      textColor: 'text-black',
      offsetTop: 'md:mt-8',
    },
    {
      icon: 'solar:users-group-rounded-linear',
      title: 'COMMUNITY',
      description: 'Find players. Join global leagues. Dominate the leaderboards.',
      bgColor: 'bg-gradient-to-r from-yellow-400 to-yellow-600',
      textColor: 'text-black',
      offsetTop: 'md:mt-16',
    },
  ];

  return (
    <section className="relative bg-black text-white py-20 -skew-y-2 transform origin-top-left border-y-8 border-yellow-400 overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full bg-halftone opacity-5 pointer-events-none skew-y-2"></div>

      <div className="container mx-auto px-4 transform skew-y-2">
        <div className="flex flex-col md:flex-row gap-8 justify-center items-stretch">
          {features.map((feature, index) => (
            <div key={index} className={`flex-1 group ${feature.offsetTop || ''}`}>
              <div className={`h-full bg-black p-1 transform transition-transform duration-300 group-hover:-translate-y-2 ${index === 1 ? 'group-hover:rotate-1' : 'group-hover:-rotate-1'}`}>
                <div className={`h-full ${feature.bgColor} border-2 border-black p-6 relative overflow-hidden shadow-[4px_4px_0px_#fff]`}>
                  <div className="absolute top-0 right-0 p-4 opacity-20 transform rotate-12 group-hover:opacity-40 group-hover:scale-110 transition-all">
                    <iconify-icon icon={feature.icon} width="100" color="#000"></iconify-icon>
                  </div>
                  <div className="bg-black text-white w-12 h-12 flex items-center justify-center border-2 border-white mb-4 clip-starburst">
                    <iconify-icon icon={feature.icon} width="24"></iconify-icon>
                  </div>
                  <h3 className="font-anton text-3xl mb-2 transform -skew-x-6 text-black">{feature.title}</h3>
                  <p className="font-sans font-medium leading-tight text-black/80">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
